<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.fiscalDatum', 2) }}
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-form @submit.prevent="submit">
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="fiscalDatum.business_name"
                                  name="business_name"
                                  :label="$t('attrs.business_name')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('business_name')"
                                  data-vv-name="business_name"
                                  :data-vv-as="$t('attrs.business_name')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="fiscalDatum.rfc"
                                  name="rfc"
                                  :label="$t('attrs.rfc')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('rfc')"
                                  data-vv-name="rfc"
                                  :data-vv-as="$t('attrs.rfc')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-select v-model="fiscalDatum.fiscal_regime"
                              :items="fiscalRegimes"
                              item-value="id"
                              :item-text="fiscalRegimeName"
                              :label="$t('attrs.fiscal_regime')"
                              v-validate="'required'"
                              :error-messages="errors.collect('fiscal_regime')"
                              data-vv-name="fiscal_regime"
                              :data-vv-as="$t('attrs.fiscal_regime')"
                              required
                              ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-select v-model="fiscalDatum.payment_form"
                              :items="paymentForms"
                              item-value="id"
                              :item-text="paymentFormName"
                              :label="$t('attrs.payment_form')"
                              v-validate="'required'"
                              :error-messages="errors.collect('payment_form')"
                              data-vv-name="payment_form"
                              :data-vv-as="$t('attrs.payment_form')"
                              required
                              ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-select v-model="fiscalDatum.cfdi_use"
                              :items="cfdiUse"
                              item-value="id"
                              :item-text="cfdiUseText"
                              :label="$t('attrs.cfdi_use')"
                              v-validate="'required'"
                              :error-messages="errors.collect('cfdi_use')"
                              data-vv-name="cfdi_use"
                              :data-vv-as="$t('attrs.cfdi_use')"
                              required
                              ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-select v-model="fiscalDatum.country_id"
                              :items="countries"
                              item-value="id"
                              item-text="name"
                              v-validate="'required'"
                              :label="$tc('models.country')"
                              :error-messages="errors.collect('country')"
                              data-vv-name="country"
                              :data-vv-as="$t('models.country')"
                              required
                              @change="fetchStates"
                              ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-select v-model="fiscalDatum.state"
                              :items="states"
                              item-value="name"
                              item-text="name"
                              v-validate="'required'"
                              :label="$tc('models.state')"
                              :error-messages="errors.collect('state')"
                              data-vv-name="state"
                              :data-vv-as="$t('models.state')"
                              required
                              :disabled="!fiscalDatum.country_id"
                              ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="fiscalDatum.phone"
                      name="phone"
                      :label="$t('attrs.phone')"
                      v-validate="'required|max:10'"
                      :error-messages="errors.collect('phone')"
                      data-vv-name="phone"
                      :data-vv-as="$t('attrs.phone')"
                      required
                      ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="fiscalDatum.street"
                                  name="street"
                                  v-validate="'required'"
                                  :label="$t('attrs.street')"
                                  :error-messages="errors.collect('street')"
                                  data-vv-name="street"
                                  :data-vv-as="$t('attrs.street')"
                                  required
                                  ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="fiscalDatum.number"
                                  name="number"
                                  :label="$t('attrs.number')"
                                  ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="fiscalDatum.interior_number"
                                  name="interior_number"
                                  :label="$t('attrs.interior_number')"
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="fiscalDatum.neighborhood"
                                  name="neighborhood"
                                  v-validate="'required'"
                                  :label="$t('attrs.neighborhood')"
                                  :error-messages="errors.collect('neighborhood')"
                                  data-vv-name="neighborhood"
                                  :data-vv-as="$t('attrs.neighborhood')"
                                  required
                                  ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="fiscalDatum.city"
                                  name="city"
                                  v-validate="'required'"
                                  :label="$t('attrs.city')"
                                  :error-messages="errors.collect('city')"
                                  data-vv-name="city"
                                  :data-vv-as="$t('attrs.city')"
                                  required
                                  ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="fiscalDatum.postal_code"
                                  name="postal_code"
                                  v-validate="'required|max:6'"
                                  :label="$t('attrs.postal_code')"
                                  :error-messages="errors.collect('postal_code')"
                                  data-vv-name="postal_code"
                                  :data-vv-as="$t('attrs.postal_code')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark :loading="loading" :disabled="loading" type="submit">{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Country from '@/client/country'
import State from '@/client/state'
import FiscalDatum from '@/client/fiscal-datum'

import CfdiUse from '@/cfdi-use.json'
import PaymentForms from '@/payment-forms.json'
import FiscalRegimes from '@/fiscal-regimes.json'

export default {
  name: 'FiscalDataFormView',

  props: {},

  data () {
    return {
      loading: false,
      fiscalDatum: {},
      countries: [],
      states: [],
      paymentForms: PaymentForms,
      fiscalRegimes: FiscalRegimes,
      cfdiUse: CfdiUse,
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    fiscalRegimeName(item) {
      return `${item.id} - ${item.name}`
    },

    cfdiUseText(item) {
      return `${item.id} - ${item.name}`
    },

    paymentFormName(item) {
      return `${item.id} - ${item.name}`
    },

    async fetchStates () {
      if (!this.fiscalDatum.country_id) { return }

      this.states = []
      this.states = await State.all({
        where: { country_id: this.fiscalDatum.country_id },
        per_page: 2000
      })
    },

    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        this.fiscalDatum.user_id = this.$auth.currentUser.id
        await this.fiscalDatum.save()
        this.setNotification({
          color: 'success',
          message: this.$t('successfullySavedNotification')
        })
        this.goTo('home')
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    }
  },

  watch: {
  },

  async mounted () {
    this.fiscalDatum = await FiscalDatum.findOne(0)

    this.countries = await Country.all({ per_page: 2000, order: 'name ASC', fast_search: true })
    this.fetchStates()
  }
}
</script>
